interface NavigationRouteProps {
  path: [number, number][]; // ordered points from Dijkstra
  startLabel?: string; // e.g. "Your office (34510)"
  endLabel?: string; // e.g. "34514"
  distanceMeters?: number; // walking distance
}

export function NavigationRoute({
  path,
  startLabel,
  endLabel,
  distanceMeters,
}: NavigationRouteProps) {
  if (path.length < 2) return null;

  const points = path.map((p) => p.join(",")).join(" ");
  const [startX, startY] = path[0];
  const [endX, endY] = path[path.length - 1];

  // Midpoint for the distance badge
  const midIdx = Math.floor(path.length / 2);
  const [midX, midY] = path[midIdx];

  return (
    <g style={{ pointerEvents: "none" }}>
      {/* Animated route polyline */}
      <polyline
        points={points}
        fill="none"
        stroke="#3b82f6"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="8,5"
      >
        <animate
          attributeName="stroke-dashoffset"
          from="26"
          to="0"
          dur="1s"
          repeatCount="indefinite"
        />
      </polyline>

      {/* Start marker */}
      <circle cx={startX} cy={startY} r={6} fill="#3b82f6" stroke="#fff" strokeWidth={2} />
      {startLabel && (
        <text
          x={startX}
          y={startY - 10}
          textAnchor="middle"
          dominantBaseline="auto"
          fontSize={10}
          fontWeight={600}
          fill="#1e293b"
        >
          {startLabel}
        </text>
      )}

      {/* End marker */}
      <circle cx={endX} cy={endY} r={6} fill="#f97316" stroke="#fff" strokeWidth={2} />
      {endLabel && (
        <text
          x={endX}
          y={endY - 10}
          textAnchor="middle"
          dominantBaseline="auto"
          fontSize={10}
          fontWeight={600}
          fill="#1e293b"
        >
          {endLabel}
        </text>
      )}

      {/* Distance badge */}
      {distanceMeters !== undefined && (
        <g>
          <rect
            x={midX - 16}
            y={midY - 10}
            width={32}
            height={16}
            rx={4}
            fill="#1e293b"
            fillOpacity={0.75}
          />
          <text
            x={midX}
            y={midY}
            textAnchor="middle"
            dominantBaseline="central"
            fontSize={9}
            fontWeight={600}
            fill="#f8fafc"
          >
            ~{Math.round(distanceMeters)}m
          </text>
        </g>
      )}
    </g>
  );
}
